import { toast } from "sonner";

/**
 * Show a toast that accurately reflects what the intake confirm endpoint
 * actually saved. Success is driven by the explicit `action` field on
 * each entry in the backend's `created[]` array — NOT inferred from
 * generic counts.
 *
 * Backend contract (POST /api/intake/{id}/confirm):
 *   { created: [ { type, id, action?, duplicate_of?, target_entity_name? , ...}, ... ] }
 *   Organization actions carry action = "organization_created" | "organization_updated".
 */
export function showIntakeConfirmToast(created) {
  const list = Array.isArray(created) ? created : [];
  if (list.length === 0) {
    toast.info("Nothing was saved.");
    return;
  }
  if (list.length === 1) {
    const only = list[0] || {};
    if (only.action === "organization_created") {
      toast.success("Organization saved to Alias Compass.");
      return;
    }
    if (only.action === "organization_updated") {
      toast.success("Organization updated in Alias Compass.");
      return;
    }
  }
  toast.success(
    `Created ${list.length} record${list.length === 1 ? "" : "s"} across HQ.`
  );
}
